module.exports = __webpack_public_path__ + "static/f1-457f70b1cee52b33f4c4d67a61a2a86e.jpg";